export const regex = {
  email:
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/is,
  otp: /^(\d+)$/,
  phoneMask: /[+\d](?=\d{3})/gs,
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?~+\\/'^:,(){}[\]\-_.])[A-Za-z\d#$@!%&*?~+\\/'^:,(){}[\]\-_.]{8,}$/,
  url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm,
};
